export class CoreProperty {
    refName: string;
    value: string;
    friendlyName: string;
}
